import supabase from "../helper/supabaseClient";
import { config } from "./config";

type DashboardRedirectOptions = {
  slug?: string;
  path?: string;
  fallbackAccessToken?: string | null;
  fallbackRefreshToken?: string | null;
};

const buildDashboardBaseUrl = (path?: string) => {
  const normalizedPath = path?.trim();
  if (!normalizedPath) return new URL(config.DASHBOARD_URL);
  return new URL(
    `${config.DASHBOARD_URL.replace(/\/$/, "")}/${normalizedPath.replace(
      /^\//,
      ""
    )}`
  );
};

export const buildDashboardRedirectUrl = async ({
  slug,
  path,
  fallbackAccessToken,
  fallbackRefreshToken,
}: DashboardRedirectOptions = {}) => {
  const dashboardUrl = buildDashboardBaseUrl(path);

  if (slug) {
    dashboardUrl.searchParams.set("slug", slug);
  }

  const { data: sessionData } = await supabase.auth.getSession();
  const accessToken =
    sessionData.session?.access_token || fallbackAccessToken || "";
  const refreshToken =
    sessionData.session?.refresh_token || fallbackRefreshToken || "";

  if (accessToken && refreshToken) {
    dashboardUrl.searchParams.set("access_token", accessToken);
    dashboardUrl.searchParams.set("refresh_token", refreshToken);
  }

  return dashboardUrl.toString();
};

export const redirectToDashboard = async (
  options: DashboardRedirectOptions = {}
) => {
  const redirectUrl = await buildDashboardRedirectUrl(options);
  window.location.href = redirectUrl;
};
